module.exports = __webpack_public_path__ + "img/郑俊.8b1f4f4b.jpg";